import script from "./SubTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./SubTableRow.vue?vue&type=style&index=0&id=36fea998&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fea998"]])

export default __exports__